import styled from "styled-components"
import { ActionButtonContainer, IconContainer, LabelContainer, Label } from './ActionButton.styles';

import topUpIcon from '@assets/icons/ActionButtonTopUp.svg'
import redeemIcon from '@assets/icons/ActionButtonRedeem.svg'
import p2pTransferIcon from '@assets/icons/ActionButtonP2PTransfer.svg'
import paymentLinkIcon from '@assets/icons/ActionButtonPaymentLink.svg'
import ppobIcon from '@assets/icons/ActionButtonPayment.svg'
import autoTransferIcon from '@assets/icons/ActionButtonAutoTransfer.svg'
import cashDeliveryIcon from '@assets/icons/ActionButtonCashDelivery.svg'
import { useTranslation } from 'react-i18next'

export const ActionTopUpIcon = styled.img.attrs({ src: topUpIcon })``
export const ActionRedeemIcon = styled.img.attrs({ src: redeemIcon })``
export const ActionP2PTransferIcon = styled.img.attrs({ src: p2pTransferIcon })``
export const ActionPaymentLinkIcon = styled.img.attrs({ src: paymentLinkIcon })``
export const ActionPPOBIcon = styled.img.attrs({ src: ppobIcon })``
export const ActionAutoTransferIcon = styled.img.attrs({ src: autoTransferIcon })``
export const ActionCashDeliveryIcon = styled.img.attrs({ src: cashDeliveryIcon })``

type Props = {
    type: 'top-up' | 'redeem' | 'p2p-transfer' | 'payment-link' | 'ppob' | 'auto-transfer' | 'cash-delivery'
    onClick?: () => void
    disabled?: boolean
}

const ActionButton = ({ type, onClick, disabled }: Props) => {
    const { t } = useTranslation();

    let ActionButtonIcon: typeof ActionTopUpIcon;
    let LabelText: string;
    switch (type) {
        case 'top-up':
            ActionButtonIcon = ActionTopUpIcon;
            LabelText = t('components.actionButton.topUp')
            break;
        case 'redeem':
            ActionButtonIcon = ActionRedeemIcon;
            LabelText = t('components.actionButton.redeem')
            break;
        case 'p2p-transfer':
            ActionButtonIcon = ActionP2PTransferIcon;
            LabelText = t('components.actionButton.transfer')
            break;
        case 'payment-link':
            ActionButtonIcon = ActionPaymentLinkIcon;
            LabelText = t('components.actionButton.receive')
            break;
        case 'ppob':
            ActionButtonIcon = ActionPPOBIcon;
            LabelText = t('components.actionButton.payment')
            break;
        case 'auto-transfer':
            ActionButtonIcon = ActionAutoTransferIcon;
            LabelText = t('components.actionButton.autoTransfer')
            break;
        case 'cash-delivery':
            ActionButtonIcon = ActionCashDeliveryIcon;
            LabelText = t('components.actionButton.cashDelivery')
            break;
    }

    return (
        <ActionButtonContainer $disabled={disabled} onClick={disabled ? undefined : onClick}>
            <IconContainer $disabled={disabled}>
                <ActionButtonIcon style={disabled ? { filter: 'grayscale(60%)' } : undefined} />
            </IconContainer>
            <LabelContainer>
                <Label $disabled={disabled}>{LabelText}</Label>
            </LabelContainer>
        </ActionButtonContainer>
    )
}

export default ActionButton
